import { createAction, props } from '@ngrx/store';

import { PagedResponse } from '../general/models/general';
import { createFailure, createSuccess } from '../utils/action-utils';
import {
  CaseById,
  CaseByIdReply,
  CreateCase,
  SupportCenter,
} from './models/SupportCenter';

// Get Support Center Actions //
const getSupportCenterKey = '[Support Center] Get Support Center';
export const getSupportCenter = createAction(
  getSupportCenterKey,
  props<{
    status?: string;
    pageNumber?: number;
    pageSize?: number;
    searchTerm?: string;
    sortBy?: string;
    sortDescending?: boolean;
  }>(),
);
export const getSupportCenterSuccess = createAction(
  createSuccess(getSupportCenterKey),
  props<{ supportCenter: PagedResponse<SupportCenter> }>(),
);
export const getSupportCenterFailure = createAction(
  createFailure(getSupportCenterKey),
  props<{ error: any }>(),
);

// Create Support Case Actions //
const createSupportCaseKey = '[Support Center] Create Support Case';
export const createSupportCase = createAction(
  createSupportCaseKey,
  props<{ body: CreateCase }>(),
);
export const createSupportCaseSuccess = createAction(
  createSuccess(createSupportCaseKey),
  props<{ message: string }>(),
);
export const createSupportCaseFailure = createAction(
  createFailure(createSupportCaseKey),
  props<{ error: any }>(),
);

// Get Case By Id Actions //
const getCaseByIdKey = '[Support Center] Get Case By Id';
export const getCaseById = createAction(
  getCaseByIdKey,
  props<{ id: string }>(),
);
export const getCaseByIdSuccess = createAction(
  createSuccess(getCaseByIdKey),
  props<{ caseById: CaseById }>(),
);
export const getCaseByIdFailure = createAction(
  createFailure(getCaseByIdKey),
  props<{ error: any }>(),
);

// Reply To Case Actions //
const replyToCaseKey = '[Support Center] Reply To Case';
export const replyToCase = createAction(
  replyToCaseKey,
  props<{ ticketId: string; message: string }>(),
);
export const replyToCaseSuccess = createAction(
  createSuccess(replyToCaseKey),
  props<{ reply: CaseByIdReply }>(),
);
export const replyToCaseFailure = createAction(
  createFailure(replyToCaseKey),
  props<{ error: any }>(),
);

// Close Case Actions //
const closeCaseKey = '[Support Center] Close Case';
export const closeCase = createAction(closeCaseKey, props<{ id: string }>());
export const closeCaseSuccess = createAction(
  createSuccess(closeCaseKey),
  props<{ message: string }>(),
);
export const closeCaseFailure = createAction(
  createFailure(closeCaseKey),
  props<{ error: any }>(),
);
